import { ReactElement } from 'react';

import { Street } from '@dreryk/address-common-api';

import { commonTranslationKeys, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { StreetInput } from '@dreryk/react-components';

const STREET_MAX_LENGTH = 50;

type StreetFormBeanPart = { street: Street | null };

const validationRules: ValidationRules<StreetFormBeanPart> = {
   required: true,
   maxLength: STREET_MAX_LENGTH,
};

type StreetFieldProps = Pick<FormContextValues<StreetFormBeanPart>, 'register'>;

export const StreetField = (props: StreetFieldProps): ReactElement => {
   return (
      <StreetInput
         testId={'street'}
         label={commonTranslationKeys.addressData.street}
         controller={props.register('street', validationRules)}
      />
   );
};
